import { fullDate } from "../Reusables/fullDate";
import { Link } from "react-router-dom"
import mlbLogo from "../images/Major_League_Baseball_logo.svg.png";
import eplLogo from "../images/Premier_League_Logo.svg.png";
import nflLogo from "../images/NFL-Logo.png";
import nbaLogo from "../images/nba-big-logo.png"
import wcLogo from "../images/worldcup.jpg"

const SportsHomePage = () => {
    const theDate = fullDate()
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return(
     <> 
        <div className="sports-home">
            <h1>What are you watching today?</h1>
            <div className="sports-grid">
                <Link to={`/nfl/${theDate}?tz=${encodeURIComponent(userTimezone)}`} className="sport-card">
                    <img className="sport-card__logo" src={nflLogo} alt="National Football League" />
                </Link>
                <Link to={`/nba/${theDate}?tz=${encodeURIComponent(userTimezone)}`} className="sport-card">
                    <img className="sport-card__logo" src={nbaLogo} alt="National Basketball Association" />
                </Link>
                <Link to={`/mlb/${theDate}?tz=${encodeURIComponent(userTimezone)}`} className="sport-card">
                    <img className="sport-card__logo" src={mlbLogo} alt="Major League Baseball"/>
                </Link> 
                {/* <Link to={`/epl/${theDate}?tz=${encodeURIComponent(userTimezone)}`} className="sport-card">
                    <img className="sport-card__logo" src={eplLogo} alt="English Premier League" /> */}
                <Link to={`/wc2026/${theDate}?timezone=${encodeURIComponent(userTimezone)}`} className="sport-card">
                <img className="sport-card__logo" src={wcLogo} alt="World Cup 2026" />
                </Link>
            </div>
        </div>
    </>
    )

}

export default SportsHomePage;